import { render, staticRenderFns } from "./ReviseDeviceType.vue?vue&type=template&id=27b3448b&scoped=true&"
import script from "./ReviseDeviceType.vue?vue&type=script&lang=js&"
export * from "./ReviseDeviceType.vue?vue&type=script&lang=js&"
import style0 from "./ReviseDeviceType.vue?vue&type=style&index=0&id=27b3448b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3448b",
  null
  
)

component.options.__file = "ReviseDeviceType.vue"
export default component.exports